






























import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { store } from "@/store/store";
import { ApiResponse } from "@/types/types";
import { Response_ } from "@/plugins/axios/response";
export default Vue.extend({
  name: "UserModalCreate",
  components: { Modal, Paragraph },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    onAction: {
      type: Function,
      default: () => undefined
    },
    user_ids: {
      type: Array as () => Array<string>
    }
  },
  data: () => {
    return {
      title: "Supprimer des utilisateurs",
      loading: false
    };
  },
  methods: {
    async onClickHandler(): Promise<void> {
      this.loading = true;
      const response = await this.onValidate(this.user_ids);
      if (response.status === ApiResponse.SUCCESS) {
        this.loading = false;
        this.onAction({
          type: "SUCCESS",
          title: "Suppression",
          content: (response as Response_).message
        });
        this.onClose();
      } else {
        this.loading = false;
        this.onAction({
          type: "ERROR",
          title: "Suppression",
          content: (response as Response_).message
        });
      }
    },
    displayUserEmail(id: string): string {
      return store.getters.USER_BY_ID[id].mail;
    }
  }
});
